import { Student } from "@/components/Global/DonutChart/DonutChart";
import { ASSIGNMENT_STATUS } from "@/services/assignment/constants";

export enum TrackingStatusType {
  COMPLETE = "SCORING",
  ASSIGNED = "SCHEDULED",
  IN_PROGRESS = "IN_PROGRESS",
  UNASSESSED = "UNASSESSED",
  ERROR = "ERROR",
  UNDER_REVIEW = "UNDER_REVIEW",
  PRE_READER = "PRE_READER",
  DONE = "DONE",
  NEEDS_REVIEW = "NEEDS_REVIEW", // unknown how needsReview is handled
}

export const TRACKING_COLORS: Record<TrackingStatusType, string> = {
  [TrackingStatusType.ASSIGNED]: "var(--status-scheduled)",
  [TrackingStatusType.COMPLETE]: "var(--status-under_review)",
  [TrackingStatusType.ERROR]: "var(--status-action_needed)",
  [TrackingStatusType.UNDER_REVIEW]: "var(--status-under_review)",
  [TrackingStatusType.IN_PROGRESS]: "var(--status-in_progress)",
  [TrackingStatusType.UNASSESSED]: "var(--status-unassesed)",
  [TrackingStatusType.PRE_READER]: "var(--status-complete)",
  [TrackingStatusType.DONE]: "var(--status-complete)",
  [TrackingStatusType.NEEDS_REVIEW]: "var(--status-action_needed)", // unknown how needsReview is handled
};

export const TRACKING_LABELS: Record<TrackingStatusType, string> = {
  [TrackingStatusType.ASSIGNED]: "SCHEDULED",
  [TrackingStatusType.COMPLETE]: "SCORING",
  [TrackingStatusType.ERROR]: "REASSESS",
  [TrackingStatusType.UNDER_REVIEW]: "UNDER_REVIEW",
  [TrackingStatusType.IN_PROGRESS]: "IN_PROGRESS",
  [TrackingStatusType.UNASSESSED]: "UNASSESSED",
  [TrackingStatusType.PRE_READER]: "EARLY_READER",
  [TrackingStatusType.DONE]: "COMPLETE",
  [TrackingStatusType.NEEDS_REVIEW]: "MANUAL_REVIEW", // unknown how needsReview is handled
};

function getTrackingStatus(assignment: any){
  if(!assignment || !assignment.manifest) return;
  let manifest = structuredClone(assignment).manifest;

  let statuses = manifest.map((acttype: any)=>{
    return acttype.activity.reduce((status: any,act: any)=>{
      if(act.status === "underReview") return "underReview";
      if(act.displayStatus === "prereader") return "prereader";
      if(act.displayStatus === "needsReview") return "needsReview"; // unknown how needsReview is handled
      return status;
    },acttype.status);
  });

  if([ASSIGNMENT_STATUS.DONE,ASSIGNMENT_STATUS.COMPLETE].includes(assignment.status)){
    if(statuses.includes("underReview")) return "UNDER_REVIEW";
    if(statuses.includes("prereader")) return "PRE_READER";
    if(statuses.includes("needsReview")) return "NEEDS_REVIEW"; // unknown how needsReview is handled
  }

  return assignment.status;
}

export const studentAssignmentsToTrackingStatus = (assignmentData: any, fullStudentRoster: any): Student[] => {

  return assignmentData.map((item: any) => {
    const { entityId, assignments } = item;
    const studentInfo = fullStudentRoster.find((student: any) => student.id === entityId);

    if (!studentInfo) return null;

    if (assignments.status){
      assignments.status = getTrackingStatus(assignments);
    }
    let assessmentStatus = TrackingStatusType.UNASSESSED;
    let latestActivityId = null;
    let completedDate = null;

    if (assignments.length > 0) {
      const assignment = assignments[0];

      switch(assignment.status) {
        case "ASSIGNED":
          assessmentStatus = TrackingStatusType.ASSIGNED;
          break;
        case "IN_PROGRESS":
          assessmentStatus = TrackingStatusType.IN_PROGRESS;
          break;
        case "ERROR":
          assessmentStatus = TrackingStatusType.ERROR;
          break;
        case "COMPLETE":
          assessmentStatus = TrackingStatusType.COMPLETE;
          break;
        case "DONE":
          assessmentStatus = TrackingStatusType.DONE;
          break;
        case "PRE_READER":
          assessmentStatus = TrackingStatusType.PRE_READER;
          break;
        case "UNDER_REVIEW":
          assessmentStatus = TrackingStatusType.UNDER_REVIEW;
          break;
        case "NEEDS_REVIEW":
          assessmentStatus = TrackingStatusType.NEEDS_REVIEW;
          break;
      }

      if (assessmentStatus === TrackingStatusType.DONE) {
        const assessmentManifestItems = assignment.manifest.filter(
          (m: any) => m.activityType === "assessment"
        );
        const allActivities = assessmentManifestItems
          .flatMap((m: any) => m.activity)
          .filter((a: any) => a.activityId);

        if (allActivities.length > 0) {
          const sortedActivities = [...allActivities].sort(
            (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );

          latestActivityId = sortedActivities[0].activityId;
          completedDate = sortedActivities[0].createdAt;
        }
      }
    }

    return {
      studentId: entityId,
      firstName: studentInfo.first_name,
      lastName: studentInfo.last_name,
      assessmentStatus,
      latestActivityId,
      completedDate
    };
  }).filter(Boolean);
};